import React, { useEffect, useState } from 'react';
import { ButtonGroup, Col, Container, Row } from 'reactstrap';
import { TooltipButton } from '../../inputs';
import ECCApprovalList from './ECCF/ECCApprovalList';
import TerminationApprovalList from './Termination/TerminationApprovalList';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const eccFormType = "ecc";
const terminationFormType = "exit";

export default function MainApprovalList() {
    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get("mode");

    const [formType, setFormType] = useState(mode ?? eccFormType);
    const history = useHistory();

    useEffect(() => {
        if (mode === formType)
            return;

        history.push(`/eccapprovallist?mode=${formType}`)
    }, [formType]);

    return (
        <section className="main">
            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <ButtonGroup size="sm">
                            <TooltipButton
                                id={eccFormType}
                                title="ECCF List"
                                className="btn-icon mb-2"
                                name={eccFormType}
                                active={formType === eccFormType}
                                value={eccFormType}
                                onClick={() => {
                                    setFormType(eccFormType);
                                }}
                            >
                                <i className="fas fa-th-list pt-1"></i> ECCF List
                            </TooltipButton>
                            <TooltipButton
                                id={terminationFormType}
                                title="Termination List"
                                className="btn-icon mb-2"
                                name={terminationFormType}
                                active={formType === terminationFormType}
                                value={terminationFormType}
                                onClick={() => {
                                    setFormType(terminationFormType);
                                }}
                            >
                                <i className="fas fa-th-list pt-1"></i> Exit Form List
                            </TooltipButton>
                        </ButtonGroup>
                    </Col>
                </Row>
            {
                formType === eccFormType ?
                <ECCApprovalList />
                :
                null
            }
            {
                formType === terminationFormType ?
                <TerminationApprovalList />
                :
                null
            }
            </Container>
        </section>
    );
};